import {
  CaretDoubleLeftIcon,
  CaretDoubleRightIcon,
  CaretLeftIcon,
  CaretRightIcon,
  CaretUpIcon,
  CheckIcon,
  CopySimpleIcon,
  DotsThreeIcon,
  ArrowSquareOutIcon as External,
  MagnifyingGlassIcon,
  PencilIcon,
  PlusIcon as PlusIconRegular,
  ShareIcon,
  TrashSimpleIcon,
  UsersThreeIcon,
  WarningCircleIcon,
  XIcon,
} from '@phosphor-icons/react/ssr'

export const ArrowDoubleLeftIcon = CaretDoubleLeftIcon
export const ArrowLeftIcon = CaretLeftIcon
export const ArrowDoubleRightIcon = CaretDoubleRightIcon
export const ArrowRightIcon = CaretRightIcon
export const ArrowTopIcon = CaretUpIcon
export const UserGroupIcon = UsersThreeIcon
export const SearchIcon = MagnifyingGlassIcon
export const PlusIcon = PlusIconRegular
export const CloseIcon = XIcon
export const TickIcon = CheckIcon
export const EditIcon = PencilIcon
export const RedirectIcon = ShareIcon
export const RemoveIcon = TrashSimpleIcon
export const CopyIcon = CopySimpleIcon
export const ThreeDotsIcon = DotsThreeIcon
export const ArrowSquareOutIcon = External
export const WarningCircle = WarningCircleIcon
